module.exports = __webpack_public_path__ + "img/full2-min.8c30fe2e.png";